import { AlertTriangle, LogOut, RefreshCw } from "lucide-react";
import type { AuthError } from "../lib/errors";
import { Button, Card } from "./ui";

export function RecoverableAuthError({
  error,
  retry,
  signOut,
}: {
  error: AuthError;
  retry: () => Promise<void>;
  signOut: () => Promise<void>;
}) {
  return <main className="flex min-h-screen items-center justify-center bg-slate-50 p-6">
    <Card className="w-full max-w-lg p-8 text-center">
      <div className="mx-auto flex size-14 items-center justify-center rounded-2xl bg-amber-50 text-amber-600"><AlertTriangle className="size-7" /></div>
      <p className="mt-5 text-xs font-semibold uppercase tracking-[0.16em] text-amber-600">账号状态需要处理</p>
      <h1 className="mt-2 text-2xl font-semibold text-slate-950">暂时无法进入工作台</h1>
      <p className="mt-3 text-sm leading-6 text-slate-500">{error.userMessage}</p>
      <div className="mt-7 flex flex-col-reverse justify-center gap-3 sm:flex-row">
        <Button variant="secondary" onClick={() => void signOut()}><LogOut className="size-4" />返回登录</Button>
        {error.retryable ? <Button onClick={() => void retry()}><RefreshCw className="size-4" />重新检查</Button> : null}
      </div>
    </Card>
  </main>;
}
